// @flow

import React, { PureComponent } from 'react';
import { Source } from 'react-mapbox-gl';
import { connect } from 'react-redux';
import { selectTileJSON } from '../modules/map';

import BaseStyles from './base';
import SectionStyles from './sections';
import RowStyles from './rows';
import ListingMarkerStyle from './listing-markers';
import LabelStyle from './labels';

type Props = {
  tileJSON: {},
};

class VenueStyle extends PureComponent<Props> {
  render() {
    return (
      <div>
        <Source id="venue" tileJsonSource={this.props.tileJSON} />
        <BaseStyles />
        <SectionStyles />
        <RowStyles />
        <LabelStyle />
        <ListingMarkerStyle />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tileJSON: selectTileJSON(state),
});

export default connect(mapStateToProps)(VenueStyle);



// WEBPACK FOOTER //
// ./src/styles/venue.js